import { render, staticRenderFns } from "./NotificationContentPurchase.vue?vue&type=template&id=7c3f2a8a&scoped=true&"
import script from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContentPurchase.vue?vue&type=style&index=0&id=7c3f2a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f2a8a",
  null
  
)

export default component.exports